import { AppWizardService } from '../../../services/app-wizard.service';
import { OfferAdyco } from '../../../../shared/models/settings';
import {
	FN_COMMERCIAL_STEEL_GRADE_ID,
	FN_THICKNESS_VALUE, FN_WIDTH_VALUE,
	FN_LENGTH_VALUE,
} from '../../../models/product-descriptor-a2c';

export const CACHE_BLOCK_SIZE_TABLE = 1000;

export const CELL_WIDTH_SMALL = 60;
export const CELL_WIDTH_MEDIUM = 120;
export const CELL_WIDTH_LARGE = 180;

export function getUserPivotFields(
	offerAdycoSettings: OfferAdyco | undefined,
	soldTo: string,
	familyCode: string,
	appWizardService: AppWizardService
): string[] {
	if (offerAdycoSettings) {
		const adycoFields = offerAdycoSettings.value.offerAdyco.find(
			x => x.soldTo === soldTo && x.familyCode === familyCode
		);
		if (adycoFields) {
			return adycoFields.selectedCharacteristics;
		}
	}

	return appWizardService.getState().ui.defaultFields || [
		FN_COMMERCIAL_STEEL_GRADE_ID,
		FN_THICKNESS_VALUE,
		FN_WIDTH_VALUE,
		FN_LENGTH_VALUE
	];
}
